import React from 'react';

const Checkbox = ({label, className, name,}) => {
  return (
    <label className={`checkbox-item ${className}`}>
      <input className="cursor-pointer" name={name} type="checkbox"/>
      {label && <span>{label}</span>}
    </label>
  );
};

export default Checkbox;
